import "./TaskStatus.scss";
import { useTranslation } from "react-i18next";
import { translateLabel } from "../../../../i18n/defaultLabels";

function TaskStatus({
  updateStatus,
  selectedStatus,
  showClear = false,
  statusConfig = [],
}) {
  const { t } = useTranslation();
  return (
    <div className="status-content">
      {statusConfig.map((statusItem) => (
        <div
          key={statusItem.label}
          className={`status ${selectedStatus === statusItem.label ? "selected" : ""}`}
          onClick={() => updateStatus(statusItem.label)}
          style={{
            backgroundColor: statusItem.color,
          }}
        >
          {translateLabel(statusItem.label, t)}
        </div>
      ))}
      {showClear && (
        <>
          <hr className="separator" />
          <div className="clear-button" onClick={() => updateStatus(null)}>
            {t("common.clear")}
          </div>
        </>
      )}
    </div>
  );
}

export default TaskStatus;
